module.exports = {
  API_LOCATION: 'https://api.offthecouch.io/',
  WAIVER_URL: 'https://api.console.offthecouch.io/'
}
